import { TextField } from '@mui/material';
import { styled } from '@mui/system';

export const StyledTextField = styled(TextField)({
  width: '100%',
  '& .MuiInputBase-root': {
    width: '100%'
  }
}); 